if (!customElements.get("cart-terms-checkbox")) {
  class CartTermsCheckbox extends HTMLElement {
    constructor() {
      super();
      this.onChangeBound = this.onChange.bind(this);
    }

    connectedCallback() {
      this.checkbox = this.querySelector(".cart-terms__input");
      if (!this.checkbox) return;

      this.checkbox.addEventListener("change", this.onChangeBound);
      this.updateCheckoutButtons();
    }

    disconnectedCallback() {
      if (this.checkbox) {
        this.checkbox.removeEventListener("change", this.onChangeBound);
      }
    }

    onChange() {
      this.updateCheckoutButtons();
    }

    getCheckoutButtons() {
      const footer =
        this.closest(".wt-cart__drawer__footer") ||
        this.closest(".wt-cart__footer") ||
        this.closest("form")?.parentElement ||
        this.parentElement;

      if (!footer) return [];

      return Array.from(
        footer.querySelectorAll(
          'button[name="checkout"], .btn-checkout, .cart__checkout, .additional-checkout-buttons button, .additional-checkout-buttons [role="button"], .shopify-payment-button button'
        )
      );
    }

    updateCheckoutButtons() {
      const isChecked = this.checkbox?.checked ?? false;
      const buttons = this.getCheckoutButtons();

      buttons.forEach((btn) => {
        if (isChecked) {
          btn.removeAttribute("disabled");
          btn.classList.remove("cart-terms--disabled");
        } else {
          btn.setAttribute("disabled", "disabled");
          btn.classList.add("cart-terms--disabled");
        }
      });
    }
  }

  customElements.define("cart-terms-checkbox", CartTermsCheckbox);
}
